/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Create_New_List_Get_StartedInputs */



/**
* | output |
* | --- |
* | "Create a new list to get started." |
*
* @param {Create_New_List_Get_StartedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const create_new_list_get_started = /** @type {((inputs?: Create_New_List_Get_StartedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Create_New_List_Get_StartedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Créez une nouvelle liste pour commencer.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Erstellen Sie zunächst eine neue Liste.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Per iniziare, crea un nuovo elenco.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Для начала создайте новый список.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Crea una nueva lista para comenzar.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("首先创建一个新列表。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("開始するには新しいリストを作成してください。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("शुरुआत करने के लिए एक नई सूची बनाएं।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Crie uma nova lista para começar.")
	return /** @type {LocalizedString} */ ("Create a new list to get started.")
});